import React from 'react'

function Footer() {
  return (
    <footer>
      <span>IDEA ERP — Panel produkcji</span>
    </footer>
  )
}

export default Footer
